import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className={className}>
    <path fill="#000" d="M6 8H0V6h6V0h2v6h6v2H8v6H6V8z"></path>
  </svg>
);

export default Icon;
